<!-- 柱状图 -->
<template>
    <div class="chart_box" id='chart_box'  :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px'}">
        <div id="main" class="chart1" ref='mapChartRef' :style = "{ left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
import gdMap from "./area.json";
import gdMap1 from "./china.json";
import gdMap2 from "./keyou.json";
export default {
    props: {
      index: {
        type:Number ,
        default: function () { return {} }
      },
      yearRef:{
        type: String,
        default: function () { return "2024" }
      }
    },
    setup(props) {
    const { proxy } = getCurrentInstance();
    const store = useStore();
    const index = ref(props.index);
    const componentList = ref(computed(() => store.state.chartData.componentList));
    const baseConfig = ref({})
    baseConfig.value = componentList.value[index.value].config.baseConfig;
    const dataList=ref([]);
    dataList.value=componentList.value[index.value].data.mapData;
    let mapData=ref([]);
    if(dataList.value&&dataList.value.length>0){
      mapData.value=JSON.parse(JSON.stringify(dataList.value))
    }
    const option = ref({});
    const mapChartRef = shallowRef(null);
    const chartInstance = shallowRef(null);
    const handleResize = () => {
        chartInstance.value.resize();
    };
    var chinaGeoCoordMap = {
        '北京': [116.407394,39.904211],
        '天津': [117.200983,39.084158],
        '河北': [114.530235,38.037433],
        "山西": [112.562678,37.873499],
        '内蒙古': [111.76629,40.81739],
        "辽宁": [123.431382,41.836175],
        "吉林": [125.32568,43.897016],
        "黑龙江": [126.661665,45.742366],
        "上海": [121.473662,31.230372],
        "江苏": [118.762765,32.060875],
        "浙江": [118.762765,32.060875],
        "安徽": [117.329949,31.733806],
        "福建": [117.329949,31.733806],
        "江西": [115.81635,28.63666],
        "山东": [117.019915,36.671156],
        "河南": [113.753394,34.765869],
        "湖北": [114.341745,30.546557],
        "湖南": [112.9836,28.112743],
        '广东': [113.26641,23.132324],
        '广西': [108.327546,22.815478],
        '海南': [110.349228,20.017377],
        '重庆': [106.551643,29.562849],
        '四川': [104.075809,30.651239],
        '贵州': [106.70546,26.600055],
        '云南': [102.710002,25.045806],
        '西藏': [91.117525,29.647535],
        '陕西': [108.954347,34.265502],
        '甘肃': [103.826447,36.05956],
        '青海': [101.780268,36.620939],
        '宁夏': [106.259126,38.472641],
        '新疆': [87.627704,43.793026],
        '台湾': [121.509062,25.044332],
        '香港': [114.171203,22.277468],
        '澳门': [113.543028,22.186835],
    };
    let toCoord=[121.20281, 45.22906];
    var convertData = function(data) {
        var res = [];
        for(var i = 0; i < data.length; i++) {
            var dataItem = data[i];
            var fromCoord = chinaGeoCoordMap[dataItem.name];
            if(fromCoord && toCoord) {
                res.push([{
                    coord: toCoord,
                },{
                    coord: fromCoord,
                    value: dataItem.value,
                    // visualMap: false
                }]);
            }
        }
        return res;
    };
    watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
      //OPTIONS配置
        if(newVal){
          option.value =JSON.parse(JSON.stringify(componentList.value[index.value].config.options));
          chartInit()
        }
      },{ deep: true }
    ) 
    watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
      //data配置
        if(newVal){
          dataList.value=componentList.value[index.value].data.mapData;
          mapData.value=JSON.parse(JSON.stringify(dataList.value));
          chartInit()
        }
      },{ deep: true }
    )

    watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
      //此时返回的是数组,按下标获取对应值
        if(newVal){
          baseConfig.value = componentList.value[index.value].config.baseConfig;
          setTimeout(()=>{
            handleResize()
          })
          if(baseConfig.value.pointInterval=='1'){
            clearInterval(timer.value)
            mapData.value=JSON.parse(JSON.stringify(dataList.value));
            chartInit();
          }else{
            mapData.value=[];
            inervalFun();
          }
        }
      },{ deep: true }
    );
      const chartInit = ()=>{
        chartInstance.value = echarts.init(mapChartRef.value);
        option.value.geo.map=option.value.series[0].map;
        if(option.value.series[0].map=='china'){
          echarts.registerMap('china', gdMap1);
        }else if(option.value.series[0].map=='兴隆县'){
          echarts.registerMap('兴隆县', gdMap);
        }else if(option.value.series[0].map=='keyou'){
          echarts.registerMap('keyou', gdMap2);
        }
        option.value.series.map(item=>{
          if(item.type=='lines'){
            item.data=convertData(mapData.value);
          }else{
            item.data=mapData.value;
          }
        })
        //formatter
        option.value.series[3].label.normal.formatter=function(p){
          let obj=baseConfig.value.formatterObj;
          let r='';
          if(obj.titleShow){
            r=`{tline|${p.data[obj.title]}}\n`
          }
          obj.attrs.map((item,index)=>{
            if(item.attrEname&&item.attrEname){
              r=r+`{lineT|${item.attrName+'：'+p.data[item.attrEname]}}\n`
            }
          })
          return r
        }
        chartInstance.value.setOption(option.value);
      }

      //标记点切换显示
      let timer=ref(null);
      const inervalFun=()=>{
        clearInterval(timer.value)
        let index=1;
        mapData.value.push(dataList.value[0])
        timer.value = setInterval(() => {
          if (index < dataList.value.length-1) {
            index++
          } else {
            index = 0
          }
          mapData.value = []
          mapData.value.push(dataList.value[index])
          chartInit()
        }, 6000);
      }
      
      

     onMounted(() => {
       option.value =JSON.parse(JSON.stringify(componentList.value[index.value].config.options));
       console.log('地图')
       console.log(option.value)
        chartInit();
        if(baseConfig.value.pointInterval=='1'){
          clearInterval(timer.value)
          mapData.value=JSON.parse(JSON.stringify(dataList.value));
          chartInit();
        }else{
          mapData.value=[];
          inervalFun();
        }
        window.addEventListener('resize', handleResize);
      });
      onUnmounted(() => {
        clearInterval(timer.value)
        window.removeEventListener('resize', handleResize);
      });


        return{
            option,
            mapChartRef,
            baseConfig

        }
    }
}
</script>

<style scoped>
.chart_box {position: relative;}
.chart1 {
    width: 100%;
   height: 100%;
   position: absolute;
}
</style>